/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
import uniqid from 'uniqid'

var AssetSelectorTab = function (editor) {
  var signals = editor.signals
  var container = new UI.Panel()
  container.setId('soundTab')
  container.className = 'assetSelectorContainer'
  var selected = null

  function build () {
    container.clear()
    if (selected === null) {
      return
    }

    if (selected.type === 'Character') {
      editor.characterModels.forEach(characterModel => {
        var row = new UI.Row()
        try {
          var image = new UI.Image(characterModel.image.imageURL)
            .setDataName(characterModel.name)
            .setWidth('180px')
            .addHoverOver(
              characterModel.image.imageURL,
              `${characterModel.name} (${characterModel.rig})`,
              `Description: ${characterModel.description || 'N/A'}`,
              `<br>Dimension: (${characterModel.dimension.X},
                               ${characterModel.dimension.Y},
                               ${characterModel.dimension.Z})
               <br>Service: ${characterModel.service || 'N/A'}`
            )
          image.onClick(function (e) {
            selected.phase = 'assetSelected'
            selected.name = characterModel.name
            selected.value = characterModel.characterModelId
            selected.assetUrl = characterModel.image.imageURL
            signals.animationPhaseChanged.dispatch(selected)
            signals.animationRenamed.dispatch(selected)
          })
          row.add(image).setTextAlign('center')
          container.add(row)
        } catch (err) {
          console.log(err, characterModel)
        }
      })
    } else if (selected.type === 'Experience') {
      editor.sceneExperiences.forEach(sceneExperienceElement => {
        var row = new UI.Row()
        var sceneExperience = new UI.Text(sceneExperienceElement)
          .setWidth('180px')
          .setCursor('pointer')
        sceneExperience.onClick(function (e) {
          selected.phase = 'assetSelected'
          selected.name = e.target.innerHTML
          signals.animationPhaseChanged.dispatch(selected)
          signals.animationRenamed.dispatch(selected)
        })
        row.add(sceneExperience)
          .setTextAlign('center')
          .setPadding('10px')
          .setBackgroundColor('#121212')
          .setBorderRadius('8px')
        container.add(row)
      })
    } else if (selected.type === 'Overlay') {
      editor.overlayItems.forEach(overlayItem => {
        var row = new UI.Row()
        row.setCursor('pointer')
        var overlay = new UI.Text(overlayItem.filename).setWidth('180px').setCursor('pointer')
        overlay.onClick(function (e) {
          selected.phase = 'assetSelected'
          selected.name = e.target.innerHTML
          signals.animationPhaseChanged.dispatch(selected)
          signals.animationRenamed.dispatch(selected)
        })
        row.add(overlay)
          .setTextAlign('center')
          .setPadding('10px')
          .setBackgroundColor('#121212')
          .setBorderRadius('8px')
        container.add(row)
      })
    } else if (selected.type === 'Set Design') {
      editor.setDesignItems.forEach(setDesignItem => {
        var row = new UI.Row()
        var setDesign = new UI.Image(setDesignItem.image.imageURL)
          .setDataName(setDesignItem.name)
          .setWidth('180px')
          .addHoverOver(
            setDesignItem.image.imageURL,
            setDesignItem.name,
            setDesignItem.description,
            ''
          )
        setDesign.onClick(function (e) {
          setDesignItem.existing_props.forEach(existingProp => {
            const enabled = true
            const prop = new FRAME.Animation(
              uniqid(),
              existingProp.name,
              selected.start,
              selected.end,
              selected.layer++, new FRAME.Effect('Effect'),
              enabled,
              'Prop',
              [],
              {
                position: existingProp.defaultPosition,
                rotation: existingProp.defaultRotation
              },
              selected.destination,
              'assetSelected',
              existingProp.image.imageURL,
              existingProp.name
            )
            editor.addAnimation(prop)
          })
          editor.removeAnimation(selected)
          editor.signals.animationSelected.dispatch(null)
        })
        row.add(setDesign).setTextAlign('center')
        container.add(row)
      })
    } else if (selected.type === 'Sound') {
      editor.soundItems.forEach(soundItem => {
        var row = new UI.Row().setId('soundBox')
        var text = new UI.Text(soundItem.audio.audioName).setWidth('180px').setCursor('pointer')
        var audioPlayer = new UI.Audio(soundItem.audio.audioURL)
        audioPlayer.setId('audioPlayer')
        text.onClick(function (e) {
          selected.phase = 'assetSelected'
          selected.name = e.target.innerHTML
          signals.animationPhaseChanged.dispatch(selected)
          signals.animationRenamed.dispatch(selected)
        })
        row.add(text)
        row.add(audioPlayer)
        container.add(row)
      })
    } else if (selected.type === 'Prop') {
      editor.propItems.forEach(propItem => {
        var row = new UI.Row()
        if (propItem.image !== undefined) {
          var prop = new UI.Image(propItem.image.imageURL)
            .setDataName(propItem.name)
            .setWidth('180px')
            .addHoverOver(propItem.image.imageURL, propItem.name, propItem.description, '')
          prop.onClick(function (e) {
            if (selected !== undefined) {
              selected.phase = 'assetSelected'
              selected.name = propItem.name
              selected.value = propItem.propId
              selected.assetUrl = propItem.image.imageURL
            }
            signals.animationRenamed.dispatch(selected)
            signals.animationPhaseChanged.dispatch(selected)
          })
        }
        if (prop !== undefined) {
          row.add(prop).setTextAlign('center')
        }
        container.add(row)
      })
    }
  }

  //

  // signals.editorCleared.add( function () {

  // selected = null;
  // build();

  // } );

  signals.animationPhaseChanged.add(function (animation) {
    selected = animation
    build()
  })

  signals.animationSelected.add(function (animation) {
    selected = animation
    build()
  })

  signals.effectCompiled.add(build)

  /*
  signals.timeChanged.add( function () {
    if ( selected !== null ) {
      for ( var key in values ) {
        values[ key ].setValue( selected.module.parameters[ key ].value );
      }
    }
  });
  */

  return container
}

export default AssetSelectorTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/AssetSelectorTab.js
// module id = null
// module chunks = 